import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["disabled", "type"]
const _hoisted_2 = {
  key: 0,
  class: "w-full flex items-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("button", {
    class: "TheButton",
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitClick && _ctx.emitClick(...args))),
    type: _ctx.type
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_loader)
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }),
    (Boolean(_ctx.hint))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          ref: "hintref",
          class: _normalizeClass(`TheButton__hint ${_ctx.hintColor}`),
          style: _normalizeStyle(`left: -${_ctx.hintHalfWidth}px`)
        }, _toDisplayString(_ctx.hint), 7))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}